import { render, staticRenderFns } from "./typical.vue?vue&type=template&id=2d9704a4"
import script from "./typical.vue?vue&type=script&lang=js"
export * from "./typical.vue?vue&type=script&lang=js"
import style0 from "./typical.vue?vue&type=style&index=0&id=2d9704a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports